import { makeStyles } from '@material-ui/core/styles'
import { calcMargin } from '@v4/utils/theme'

const useStyles = makeStyles(
	theme => ({
		root: {
			minHeight: ({ metaData, autoHeight }) => (!autoHeight ? metaData.bannerHeight?.metaValue ?? null : null),
			transition: theme.transitions.create(['padding-top', 'padding-bottom']),
			[theme.breakpoints.down('sm')]: {
				paddingTop: ({ metaData, minMarginTop }) => {
					return calcMargin({
						spacing: theme.spacing,
						value: metaData.marginTop?.metaValue,
						minMargin: minMarginTop,
						isMobile: true,
					})
				},
				paddingBottom: ({ metaData, minMarginBottom }) => {
					return calcMargin({
						spacing: theme.spacing,
						value: metaData.marginBottom?.metaValue,
						minMargin: minMarginBottom,
						isMobile: true,
					})
				},
			},
			[theme.breakpoints.down('xs')]: {
				paddingTop: ({ metaData, minMarginTop }) => {
					if (!metaData.overrideXsMargins?.toBoolean()) {
						return null
					}
					return calcMargin({
						spacing: theme.spacing,
						value: metaData.xsMarginTop?.metaValue,
						minMargin: minMarginTop,
						isMobile: true,
					})
				},
				paddingBottom: ({ metaData, minMarginBottom }) => {
					if (!metaData.overrideXsMargins?.toBoolean()) {
						return null
					}

					return calcMargin({
						spacing: theme.spacing,
						value: metaData.xsMarginBottom?.metaValue,
						minMargin: minMarginBottom,
						isMobile: true,
					})
				},
			},
			[theme.breakpoints.up('md')]: {
				paddingTop: ({ metaData, minMarginTop }) => {
					return calcMargin({
						spacing: theme.spacing,
						value: metaData.marginTop?.metaValue,
						minMargin: minMarginTop,
					})
				},
				paddingBottom: ({ metaData, minMarginBottom }) => {
					return calcMargin({
						spacing: theme.spacing,
						value: metaData.marginBottom?.metaValue,
						minMargin: minMarginBottom,
					})
				},
			},
		},
	}),
	{ name: 'SectionItem-BaseContainer' },
)

export default useStyles
